import { fDateTime } from 'src/utils/formatTime';

export default function DrawerNegocioTimeline({ data }) {
    return (
        <div className="flex flex-col mt-2">
            {data && data.map((option, index) => {
                let dotClass = 'bg-gray-400';
                if (option.action === 'scoring_point_added') {
                    dotClass = option.scope?.type === 'credit' ? 'bg-green-500' : 'bg-red-500';
                }

                return (
                    <div key={index} className="flex gap-3 relative">
                        {/* Linha vertical + dot */}
                        <div className="flex flex-col items-center">
                            <div className={`w-2.5 h-2.5 rounded-full ${dotClass} mt-1.5 flex-shrink-0`} />
                            {index < data.length - 1 && (
                                <div className="w-px flex-1 bg-gray-200 dark:bg-[#383838]" />
                            )}
                        </div>
                        {/* Conteúdo */}
                        <div className="pb-4 flex-1 min-w-0">
                            <p className="text-sm text-gray-800 dark:text-[#D1D2D3]">{option.descricao}</p>
                            <p className="text-xs text-gray-400 dark:text-[#ABABAD] mt-0.5">{fDateTime(option.date)}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
